import { Component } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BusinessLoginComponent } from '../business-login/business-login.component';
import { RegisterBusinessComponent } from '../register-business/register-business.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-service-offer-dialog',
  templateUrl: './service-offer-dialog.component.html',
  styleUrls: ['./service-offer-dialog.component.scss']
})
export class ServiceOfferDialogComponent {
  
  selectedOption: string | null = null;

 options = [
  {
    key: 'rental',
    title: 'Heavy Equipment Rental',
    desc: '',
    img: 'assets/landingpage/Vehicles-icon.svg'
  },
  {
    key: 'garage',
    title: 'Garage',
    desc: '',
    img: 'assets/landingpage/Garages-icon.svg'
  },
  {
    key: 'services',
    title: 'Other Services',
    desc: '',
    img: 'assets/landingpage/Other-services-icon.svg'
  }
];


  constructor(private dialogRef: MatDialogRef<ServiceOfferDialogComponent>,public dialog: MatDialog, private router: Router,) {}

  selectOption(key: string) {
    this.selectedOption = key;
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onNext() {
    this.dialogRef.close(this.selectedOption);
  }
  openBusinessLoginPopup() {
  // Close the current dialog first
  this.dialogRef.close();

  // Then open the next popup
  // this.dialog.open(RegisterBusinessComponent, {
  //   disableClose: false,
  //   panelClass: 'dialogupload',
  //   backdropClass: 'blurred-backdrop'
  // });
   this.router.navigate(['/register-business']);
}

}
